/**
 * datebar 容器裸 DOM 渲染(仅兜底用)
 *
 * 正常路径由 React(DateBarApp)在 Shadow DOM 内渲染;此处仅保留 renderError,
 * 用于 createRoot 挂载本身失败时的最终降级(B9),样式复用 SDK_STYLE 保持一致。
 * 内容为固定文案,innerHTML 安全。
 */
import { SDK_STYLE } from '../lib/styles';
import { SDK_STYLE_H5 } from '../lib/styles.h5';

/** 渲染挂载失败兜底(createRoot 异常等) */
export function renderError(root: ShadowRoot): void {
  root.innerHTML = `<style>${SDK_STYLE}${SDK_STYLE_H5}</style><div class="hh-error">加载失败,请稍后重试</div>`;
}
